// extracted by mini-css-extract-plugin
export default {"container":"Logo_container__G2Ryl","text":"Logo_text__3pm4b","imgBox":"Logo_imgBox__GCaex","logo":"Logo_logo__po8lN"};